import { useQuery } from '@tanstack/react-query';
import { apiClient as api } from '@plerionhq/design-system';

export interface TenantUsage {
  tenantCap: number | null;
  startDate: string;
  endDate: string;
  consumedPlerionUnits: number;
  shouldBlockTenantUsage?: boolean;
  remainingPlerionUnits: number | null;
  shouldBlockOrgUsage?: boolean;
}
/**
 * Tenant usage, for the billing-limit banners in the shell.
 *
 * `enabled` because the shell mounts this on every authenticated page, and the
 * route needs Tenant:Read. A caller scoped to some of the tenant's
 * integrations does not hold it, so leaving the query on meant a 403 on every
 * page load for a banner they can neither see nor act on.
 */
export function useTenantUsage(enabled = true) {
  return useQuery({
    enabled,
    queryKey: ['tenantUsage'],
    queryFn: () =>
      api
        .get<{ data: TenantUsage }>(`/api/base/tenant/usage`, {})
        .then((res) => res.data.data),
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
}
